import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import api from '../../services/api';

const UPLOADS_BASE = process.env.REACT_APP_UPLOADS_URL || 'https://www.businessmateworkflow.in';

const BlogSectionSlider = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlogPosts = async () => {
      try {
        // Was previously hardcoded to https://www.startupbusinesspartners.com
        // (the old, retired domain) via a raw axios call - that request was
        // doomed to hang/fail on every page load. Now uses the shared `api`
        // instance, which respects REACT_APP_API_URL, and the new
        // SEO-aware blog-list endpoint.
        const response = await api.get('/blog-list', { params: { limit: 6 } });

        if (response.data.success) {
          setPosts(response.data.data);
        } else {
          throw new Error(response.data.message || 'Failed to fetch posts');
        }
      } catch (err) {
        setError(err.message);
        console.error('Error fetching blog posts:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogPosts();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  if (loading) {
    return (
      <div className="text-center py-8">
        <p>Loading blog posts...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-8 text-red-500">
        <p>Error loading blog posts: {error}</p>
      </div>
    );
  }

  return (
    <section className="py-24 bg-gray-100">
     <div className="mx-auto px-4 bg-white shadow-lg rounded-lg p-6" style={{ padding: '20px 40px' }}>
     
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold text-gray-800 mb-2">Our Latest Blog</h2>
          <p className="text-gray-600">Latest updates and articles from our community</p>
        </div>

        {posts.length > 0 ? (
          <Slider {...settings}>
            {posts.map((post) => (
              <div key={post.id} className="px-3">
                <div className="bg-white rounded-lg overflow-hidden shadow-md h-full flex flex-col">
                  <a href={`/blog/${post.slug}`}>
                    <img
                      src={
                        post.image_url && post.image_url.trim() !== ""
                          ? `${UPLOADS_BASE}/${post.image_url}`
                          : "https://images.unsplash.com/photo-1499750310107-5fef28a66643?w=800&q=80"
                      }
                      alt={post.image_alt_text || post.title}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "https://images.unsplash.com/photo-1499750310107-5fef28a66643?w=800&q=80";
                      }}
                      style={{ width: "100%", height: "200px", objectFit: "cover" }}
                    />
                  </a>
                  <div className="p-4 flex flex-col flex-grow">
                    <h3 className="text-md font-small text-gray-800 mb-2" style={{ fontSize: '17px' }}>
                      <a href={`/blog/${post.slug}`} className="hover:text-blue-600 block">
                        {post.title.split(' ').slice(0, 7).join(' ')}
                        {post.title.split(' ').length > 7 ? '...' : ''}
                      </a>
                    </h3>

                    <div className="text-sm text-gray-500 mb-2">
                      <span>{formatDate(post.published_at || post.created_at)}</span>
                      {post.tags && post.tags.length > 0 && (
                        <span className="ml-3">
                          Tags: {post.tags.map((t) => (typeof t === 'string' ? t : t.name)).join(', ')}
                        </span>
                      )}
                    </div>
                    <p
                      className="text-gray-600 text-sm flex-grow"
                      style={{
                        display: "-webkit-box",
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: post.excerpt || post.content,
                      }}
                    ></p>
                    <a
                      href={`/blog/${post.slug}`}
                      className="mt-4 inline-block text-blue-500 hover:underline font-medium"
                    >
                      Read More
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        ) : (
          <div className="text-center py-8">No blog posts available at the moment.</div>
        )}
      </div>
    </section>
  );
};

export default BlogSectionSlider;
